/* ========================================================================
 * Apricot's Spinner
* ======================================================================== */

// SCSS
import '../scss/includes/apricot-base.scss';
import '../scss/includes/spinner.scss';

// javaScript
export default {}